// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Info Tooltip Styles */
.ProductInfo_infoTooltipWrapper__l5Fe2 {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  cursor: help;
}

.ProductInfo_infoIcon__pYNc\\+ {
  color: #6c757d;
  font-size: 14px;
  transition: color 0.2s ease;
}

.ProductInfo_infoIcon__pYNc\\+:hover {
  color: #007bff;
}

.ProductInfo_infoTooltip__EyPu0 {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  max-width: 280px;
  white-space: normal;
  word-wrap: break-word;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: left;
  line-height: 1.4;
}

.ProductInfo_infoTooltip__EyPu0::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1f2937;
}

/* Product Info Section Styles */
.ProductInfo_productInfoSection__zxZSc {
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
}

.ProductInfo_productInfoTitle__mPf6x {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.ProductInfo_productInfoDescription__wUgSf {
  margin: 0 0 20px 0;
  font-size: 14px;
  opacity: 0.9;
  color: white;
}

.ProductInfo_productInfoForm__pCw8z {
  background: white;
  border-radius: 8px;
  padding: 20px;
  color: #333;
}

.ProductInfo_formGroup__bughq {
  margin-bottom: 20px;
}

.ProductInfo_formLabel__-xdob {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.ProductInfo_optionalTag__MYDTX {
  font-size: 12px;
  font-weight: normal;
  color: #666;
  margin-left: 8px;
}

.ProductInfo_productNameInput__XoY2k {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.ProductInfo_productNameInput__XoY2k:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.ProductInfo_productSummaryTextarea__Wj\\+sK {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.3s ease;
}

.ProductInfo_productSummaryTextarea__Wj\\+sK:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.ProductInfo_formHint__q0ToE {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #666;
}

.ProductInfo_characterCount__wvink {
  text-align: right;
  font-size: 11px;
  color: #999;
  margin-top: 5px;
}

.ProductInfo_productInfoActions__wKiEI {
  margin-top: 20px;
  text-align: right;
}

.ProductInfo_saveProductButton__mQP1M {
  padding: 10px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.ProductInfo_saveProductButton__mQP1M:hover:not(.ProductInfo_disabled__l-5AW) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.ProductInfo_saveProductButton__mQP1M.ProductInfo_disabled__l-5AW {
  opacity: 0.5;
  cursor: not-allowed;
}

.ProductInfo_productInfoMessage__T\\+R6x {
  margin-top: 15px;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
}

.ProductInfo_productInfoMessage__T\\+R6x.ProductInfo_success__BfAgn {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.ProductInfo_productInfoMessage__T\\+R6x.ProductInfo_error__QWwdI {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.ProductInfo_productInfoDivider__EVC5i {
  margin: 20px 0 0 0;
  border: none;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.ProductInfo_productInfoLoading__QqyNZ {
  text-align: center;
  padding: 20px;
  color: white;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/ProductInfo/ProductInfo.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;qBAEmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* Info Tooltip Styles */\n.infoTooltipWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  margin-left: 6px;\n  cursor: help;\n}\n\n.infoIcon {\n  color: #6c757d;\n  font-size: 14px;\n  transition: color 0.2s ease;\n}\n\n.infoIcon:hover {\n  color: #007bff;\n}\n\n.infoTooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1f2937;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 400;\n  max-width: 280px;\n  white-space: normal;\n  word-wrap: break-word;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  text-align: left;\n  line-height: 1.4;\n}\n\n.infoTooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #1f2937;\n}\n\n/* Product Info Section Styles */\n.productInfoSection {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  color: white;\n}\n\n.productInfoTitle {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n}\n\n.productInfoDescription {\n  margin: 0 0 20px 0;\n  font-size: 14px;\n  opacity: 0.9;\n  color: white;\n}\n\n.productInfoForm {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  color: #333;\n}\n\n.formGroup {\n  margin-bottom: 20px;\n}\n\n.formLabel {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.optionalTag {\n  font-size: 12px;\n  font-weight: normal;\n  color: #666;\n  margin-left: 8px;\n}\n\n.productNameInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.productNameInput:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.productSummaryTextarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.3s ease;\n}\n\n.productSummaryTextarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.formHint {\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  color: #666;\n}\n\n.characterCount {\n  text-align: right;\n  font-size: 11px;\n  color: #999;\n  margin-top: 5px;\n}\n\n.productInfoActions {\n  margin-top: 20px;\n  text-align: right;\n}\n\n.saveProductButton {\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    opacity 0.2s ease;\n}\n\n.saveProductButton:hover:not(.disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.saveProductButton.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.productInfoMessage {\n  margin-top: 15px;\n  padding: 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.productInfoMessage.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.productInfoMessage.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.productInfoDivider {\n  margin: 20px 0 0 0;\n  border: none;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.productInfoLoading {\n  text-align: center;\n  padding: 20px;\n  color: white;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoTooltipWrapper": `ProductInfo_infoTooltipWrapper__l5Fe2`,
	"infoIcon": `ProductInfo_infoIcon__pYNc+`,
	"infoTooltip": `ProductInfo_infoTooltip__EyPu0`,
	"productInfoSection": `ProductInfo_productInfoSection__zxZSc`,
	"productInfoTitle": `ProductInfo_productInfoTitle__mPf6x`,
	"productInfoDescription": `ProductInfo_productInfoDescription__wUgSf`,
	"productInfoForm": `ProductInfo_productInfoForm__pCw8z`,
	"formGroup": `ProductInfo_formGroup__bughq`,
	"formLabel": `ProductInfo_formLabel__-xdob`,
	"optionalTag": `ProductInfo_optionalTag__MYDTX`,
	"productNameInput": `ProductInfo_productNameInput__XoY2k`,
	"productSummaryTextarea": `ProductInfo_productSummaryTextarea__Wj+sK`,
	"formHint": `ProductInfo_formHint__q0ToE`,
	"characterCount": `ProductInfo_characterCount__wvink`,
	"productInfoActions": `ProductInfo_productInfoActions__wKiEI`,
	"saveProductButton": `ProductInfo_saveProductButton__mQP1M`,
	"disabled": `ProductInfo_disabled__l-5AW`,
	"productInfoMessage": `ProductInfo_productInfoMessage__T+R6x`,
	"success": `ProductInfo_success__BfAgn`,
	"error": `ProductInfo_error__QWwdI`,
	"productInfoDivider": `ProductInfo_productInfoDivider__EVC5i`,
	"productInfoLoading": `ProductInfo_productInfoLoading__QqyNZ`
};
export default ___CSS_LOADER_EXPORT___;
